module.exports = __webpack_public_path__ + "static/media/James.46845673.jpg";